import { useState, useEffect } from 'react';

export const useUsingKeyboard = (defaultUsingKeyboard = false) => {
  const [usingKeyboard, setUsingKeyboard] = useState(defaultUsingKeyboard);

  useEffect(() => {
    const canFocus = () => setUsingKeyboard(true);
    const cantFocus = () => setUsingKeyboard(false);
    document.body.addEventListener('mousedown', cantFocus);
    document.body.addEventListener('keydown', canFocus);

    return () => {
      document.body.removeEventListener('mousedown', cantFocus);
      document.body.removeEventListener('keydown', canFocus);
    };
  }, []);

  return usingKeyboard;
};
